/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchMutationRequest,
  ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchMutationResponse,
  ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchPathParams,
  ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchHeaderParams,
  ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatch422,
} from '../../types/ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatch.ts'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

export const replyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchMutationKey = () => [{ url: '/api/v1/reply_schedule/{reply_schedule_id}' }] as const

export type ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchMutationKey = ReturnType<
  typeof replyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchMutationKey
>

/**
 * @summary Reply Schedule Update
 * {@link /api/v1/reply_schedule/:reply_schedule_id}
 */
export async function replyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatch(
  reply_schedule_id: ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchPathParams['reply_schedule_id'],
  data?: ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchMutationRequest,
  headers?: ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchHeaderParams,
  config: Partial<RequestConfig<ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const res = await request<
    ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchMutationResponse,
    ResponseErrorConfig<ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatch422>,
    ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchMutationRequest
  >({
    method: 'PATCH',
    url: `/api/v1/reply_schedule/${reply_schedule_id}`,
    data: requestData,
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  })
  return res.data
}

/**
 * @summary Reply Schedule Update
 * {@link /api/v1/reply_schedule/:reply_schedule_id}
 */
export function useReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatch<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchMutationResponse,
      ResponseErrorConfig<ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatch422>,
      {
        reply_schedule_id: ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchPathParams['reply_schedule_id']
        data?: ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchMutationRequest
        headers?: ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchHeaderParams
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchMutationRequest>> & { client?: typeof fetch }
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? replyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchMutationKey()

  return useMutation<
    ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchMutationResponse,
    ResponseErrorConfig<ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatch422>,
    {
      reply_schedule_id: ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchPathParams['reply_schedule_id']
      data?: ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchMutationRequest
      headers?: ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatchHeaderParams
    },
    TContext
  >(
    {
      mutationFn: async ({ reply_schedule_id, data, headers }) => {
        return replyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatch(reply_schedule_id, data, headers, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}